import { render, staticRenderFns } from "./DefectReopen.vue?vue&type=template&id=8737c9a4"
import script from "./DefectReopen.vue?vue&type=script&lang=js"
export * from "./DefectReopen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports